import { useMutation } from "@apollo/client";
import type { OrderInfo } from "@jasper/client-models";
import {
  GetOrderByIdDocument,
  UpdateOrderInfoDocument,
} from "../../gql/generated/graphql";

interface Props {
  orderId: string;
}

export const useUpdateOrderInfo = ({ orderId }: Props) => {
  const [updateOrderInfo] = useMutation(UpdateOrderInfoDocument, {
    refetchQueries: [GetOrderByIdDocument],
  });

  return {
    updateOrderInfo: async (orderInfo: OrderInfo) => {
      await updateOrderInfo({
        variables: {
          orderId,
          orderInfo: {
            dentistId: orderInfo.dentistId,
          },
          patient: orderInfo.patient,
        },
      });
    },
  };
};
